import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { brandInfo } from "@/mocks/brand";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-base font-semibold text-foreground-950 mb-4" style={{ fontFamily: "var(--font-heading)" }}>
              <span className="text-primary-500">萝莉</span>风格指南
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {brandInfo.tagline}，{brandInfo.description.substring(0, 60)}...
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">分类浏览</h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-600">
              <span>📧 {brandInfo.email}</span>
              <span>📍 {brandInfo.location}</span>
              <div className="flex items-center gap-3 mt-2">
                <a href={brandInfo.social.weibo} target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-foreground-700"></i>
                </a>
                <a href={brandInfo.social.xiaohongshu} target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="小红书">
                  <i className="ri-red-packet-line text-foreground-700"></i>
                </a>
                <a href={brandInfo.social.bilibili} target="_blank" rel="nofollow noopener noreferrer" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-foreground-700"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {brandInfo.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}